import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @ViewChild('settingsMenuRoot') settingsMenuRoot?: ElementRef<HTMLElement>;

  settingsMenuOpen = false;

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  logout(): void {
    this.auth.logout();
  }

  isSettingsSectionActive(): boolean {
    const u = this.router.url;
    return (
      u.startsWith('/admin/networking-objectives') ||
      u.startsWith('/admin/training-information-areas') ||
      u.startsWith('/admin/event-participation-types') ||
      u.startsWith('/admin/categories') ||
      u.startsWith('/admin/interests') ||
      u.startsWith('/admin/content-preferences')
    );
  }

  toggleSettingsMenu(event: Event): void {
    event.preventDefault();
    this.settingsMenuOpen = !this.settingsMenuOpen;
  }

  closeSettingsMenu(): void {
    this.settingsMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(ev: MouseEvent): void {
    if (!this.settingsMenuOpen) return;
    const root = this.settingsMenuRoot?.nativeElement;
    const t = ev.target as Node | null;
    if (root && t && root.contains(t)) return;
    this.settingsMenuOpen = false;
  }
}
